import React from 'react';
import { Typography } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { editorialLabelSx, midnight } from '../contestWizard/midnightStyles';

export const dashedFieldShellSx = {
    p: 2,
    borderRadius: '10px',
    border: '1px dashed rgba(72,72,71,0.45)',
    cursor: 'pointer',
    transition: 'border-color 0.2s, background-color 0.2s',
    '&:hover': {
        borderColor: 'rgba(255,201,101,0.45)',
        bgcolor: 'rgba(255,255,255,0.03)',
    },
} as const;

export const brandChipSx = {
    fontFamily: '"Manrope", Inter, sans-serif',
    fontSize: 12,
    fontWeight: 600,
    color: midnight.onSurface,
    bgcolor: midnight.surfaceContainer,
    border: '1px solid rgba(72,72,71,0.35)',
    borderRadius: '8px',
    px: 1.25,
    py: 0.5,
} as const;

export function BrandDrawerEmptyMessage({ message }: { message: string }) {
    return (
        <Typography sx={{ color: midnight.onSurfaceVariant, fontStyle: 'italic', fontSize: 14 }}>{message}</Typography>
    );
}

export function getAttachmentFileName(url?: string): string {
    if (!url) return 'attachment';
    let fileName = url.split('/').pop() || 'attachment';
    fileName = fileName.split('?')[0];
    try {
        fileName = decodeURIComponent(fileName);
    } catch {
        /* keep original */
    }
    return fileName;
}

export function getAttachmentIcon(url?: string): React.ReactNode {
    if (!url) return <AttachFileOutlinedIcon sx={{ fontSize: 28, color: midnight.onSurfaceVariant }} />;
    const fileName = url.toLowerCase();
    if (fileName.endsWith('.pdf') || fileName.includes('pdf')) {
        return <PictureAsPdfOutlinedIcon sx={{ fontSize: 28, color: '#ff7351' }} />;
    }
    if (fileName.endsWith('.zip') || fileName.includes('zip')) {
        return <FolderZipOutlinedIcon sx={{ fontSize: 28, color: midnight.primary }} />;
    }
    return <AttachFileOutlinedIcon sx={{ fontSize: 28, color: midnight.onSurfaceVariant }} />;
}

export function FieldHint({ children }: { children: string }) {
    return (
        <Typography sx={{ ...editorialLabelSx, mt: 0.5, mb: 2, letterSpacing: '0.04em', textTransform: 'none' }}>
            {children}
        </Typography>
    );
}
